import type { RUICButtonVariants, SBButtonVariants } from "../Button";

const buttonVaringsConfig: Partial<Record<SBButtonVariants, RUICButtonVariants>> = {
  primary: "primary",
  secondary: "secondary",
  tertiary: "primaryAlt",
};

export default buttonVaringsConfig;
